import React from 'react';

const Home = () => {
  return (
    <div className="home">
      <h2>Home Page</h2>
      <p>Welcome to the Classifi Chat App home page.</p>
    </div>
  );
};

export default Home;
